import i18n from 'i18next';

/** Translate display labels only. FIT/API metric keys remain unchanged. */
export function workoutMetricLabel(label: string): string {
  if (!/^fa(?:-|$)/i.test(i18n.resolvedLanguage ?? i18n.language ?? '')) return label;
  if (/^(?:r)?tss$/i.test(label)) return 'بار تمرین';
  return label === 'IF' ? 'شدت تمرین' : label;
}
